import { render, staticRenderFns } from "./RedemptionsViewPage.vue?vue&type=template&id=1f0d3822&"
import script from "./RedemptionsViewPage.vue?vue&type=script&lang=js&"
export * from "./RedemptionsViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports